import React, { Component } from "react";
import Select from "react-select";
import { Controller } from "react-hook-form";

import star from "../../../assets/star.png";
import adios from "../../../assets/adios.png";
import Api from "../../../Api";
import logo from "../../../assets/Dynamo.png";

import Buurtgericht from "./Buurtgericht";
import Groepsgericht from "./Groepsgericht";
import Persoonsgericht from "./Persoonsgericht";
class Dynamo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: 0,
      showModal: false,
      loading: false,
      case: 0,
      key: 0,
      type: "",
      type2: "",
      starFieldData: {},
      opt8: false,
      finish: true,
    };

    this.SelectField = this.SelectField.bind(this);
    this.SelectFieldStar = this.SelectFieldStar.bind(this);
    this.handleStarFieldChange = this.handleStarFieldChange.bind(this);
    this.handleSelectField = this.handleSelectField.bind(this);
    this.TextAreaField = this.TextAreaField.bind(this);
    this.onSubmit = this.onSubmit.bind(this);

  }

  async onSubmit(data) {
    this.setState({ loading: true });
    const { starFieldData = {} } = this.state;
    if (this.state.type === "Buurtgericht") {
      if (this.state.key === 46656) {
        const newAdressData = {
          embedded: this.state.id,
          linkId: 19562,
          defDossier: 4620,
          93558: [46655],
          93559: [this.state.key],
          93576: [starFieldData.youthorganizing],
          93577: [starFieldData.youthorganizing_1],
          93578: [starFieldData.youthorganizing_2],
          93579: [starFieldData.youthorganizing_3],
          93580: [starFieldData.youthorganizing_4],
          93581: [starFieldData.youthorganizing_5],
          93590: [starFieldData.youthorganizing_6],
          93591: [starFieldData.youthorganizing_7],
          93592: [starFieldData.youthorganizing_8],
          93593: [starFieldData.youthorganizing_9],
          93892: `<p>${data.woorden}</p>`,
          93891: [data.hoeoud],
          100550: new Date().toISOString()
        };
        const idnewAdressData = await Api.dossiers.Create(newAdressData);

      } else {
        const newAdressData = {
          embedded: this.state.id,
          linkId: 19562,
          defDossier: 4620,
          93558: [46655],
          93559: [this.state.key],
          93562: [starFieldData.buurtgericht],
          93563: [starFieldData.buurtgericht_1],
          93564: [starFieldData.buurtgericht_2],
          93565: [starFieldData.buurtgericht_3],
          93566: [starFieldData.buurtgericht_4],
          93567: [starFieldData.buurtgericht_5],
          93568: [starFieldData.buurtgericht_6],
          93569: [starFieldData.buurtgericht_7],
          93570: [starFieldData.buurtgericht_8],
          93571: [starFieldData.buurtgericht_9],
          93892: `<p>${data.woorden}</p>`,
          93891: [data.hoeoud],
          100550: new Date().toISOString()

        };
        const idnewAdressData = await Api.dossiers.Create(newAdressData);

      }
    }

    if (this.state.type === "Groepsgericht") {
      if (this.state.key === 46658) {
        const newAdressData = {
          embedded: this.state.id,
          linkId: 19562,
          defDossier: 4620,
          93558: [46654],
          93560: [this.state.key],
          93565: [starFieldData.meidenwerk_1],
          93566: [starFieldData.meidenwerk_2],
          93567: [starFieldData.meidenwerk_3],
          93579: [starFieldData.meidenwerk_4],
          93580: [starFieldData.meidenwerk_5],
          93581: [starFieldData.meidenwerk_6],
          93585: [starFieldData.meidenwerk_7],
          93586: [starFieldData.meidenwerk_8],
          93587: [data.meidenwerk_9],
          93588: [data.meidenwerk_10],
          93589: [data.meidenwerk_11],
          93892: `<p>${data.woorden}</p>`,
          93891: [data.hoeoud],
          100550: new Date().toISOString()

        };
        const idnewAdressData = await Api.dossiers.Create(newAdressData);

      } else if (this.state.key === 46659) {
        const newAdressData = {
          embedded: this.state.id,
          linkId: 19562,
          defDossier: 4620,
          93558: [46654],
          93560: [this.state.key],
          93562: [starFieldData.inloop_1],
          93564: [starFieldData.inloop_2],
          93565: [starFieldData.inloop_3],
          93566: [starFieldData.inloop_4],
          93567: [starFieldData.inloop_5],
          93568: [starFieldData.inloop_6],
          93569: [starFieldData.inloop_7],
          93570: [starFieldData.inloop_8],
          93571: [starFieldData.inloop_9],
          93892: `<p>${data.woorden}</p>`,
          93891: [data.hoeoud],
          100550: new Date().toISOString()

        };
        const idnewAdressData = await Api.dossiers.Create(newAdressData);

      } else if (this.state.key === 46660) {
        const newAdressData = {
          embedded: this.state.id,
          linkId: 19562,
          defDossier: 4620,
          93558: [46654],
          93560: [this.state.key],
          93576: [starFieldData.talentonwikkeling_1],
          93577: [starFieldData.talentonwikkeling_2],
          93578: [starFieldData.talentonwikkeling_3],
          93579: [starFieldData.talentonwikkeling_4],
          93580: [starFieldData.talentonwikkeling_5],
          93581: [starFieldData.talentonwikkeling_6],
          93582: [starFieldData.talentonwikkeling_7],
          93583: [starFieldData.talentonwikkeling_8],
          93584: [starFieldData.talentonwikkeling_9],
          93892: `<p>${data.woorden}</p>`,
          93891: [data.hoeoud],
          100550: new Date().toISOString()

        };
        const idnewAdressData = await Api.dossiers.Create(newAdressData);

      } else if (this.state.key === 46661) {
        const newAdressData = {
          embedded: this.state.id,
          linkId: 19562,
          defDossier: 4620,
          93558: [46654],
          93560: [this.state.key],
          93562: [starFieldData.groepsgericht_1],
          93563: [starFieldData.groepsgericht_2],
          93564: [starFieldData.groepsgericht_3],
          93572: [starFieldData.groepsgericht_4],
          93573: [starFieldData.groepsgericht_5],
          93574: [starFieldData.groepsgericht_6],
          93575: [starFieldData.groepsgericht_7],
          93582: [starFieldData.groepsgericht_8],
          93583: [starFieldData.groepsgericht_9],
          93584: [starFieldData.groepsgericht_10],
          93892: `<p>${data.woorden}</p>`,
          93891: [data.hoeoud],
          100550: new Date().toISOString()

        };
        const idnewAdressData = await Api.dossiers.Create(newAdressData);

      }
    }

    if (this.state.type === "Persoonsgericht") {
      if (this.state.key === 46664) {
        const newAdressData = {
          embedded: this.state.id,
          linkId: 19562,
          defDossier: 4620,
          93558: [46653],
          93561: [this.state.key],
          93579: [starFieldData.informatie],
          93580: [starFieldData.informatie_1],
          93581: [starFieldData.informatie_2],
          93892: `<p>${data.woorden}</p>`,
          93891: [data.hoeoud],
          100550: new Date().toISOString()

        };
        const idnewAdressData = await Api.dossiers.Create(newAdressData);

      } else if (this.state.key === 46662) {
        const newAdressData = {
          embedded: this.state.id,
          linkId: 19562,
          defDossier: 4620,
          93558: [46653],
          93561: [this.state.key],
          93572: [starFieldData.peer_1],
          93573: [starFieldData.peer_2],
          93574: [starFieldData.peer_3],
          93575: [starFieldData.peer_4],
          93576: [starFieldData.peer_5],
          93577: [starFieldData.peer_6],
          93578: [starFieldData.peer_7],
          93582: [starFieldData.peer_8],
          93583: [starFieldData.peer_9],
          93584: [starFieldData.peer_10],
          93892: `<p>${data.woorden}</p>`,
          93891: [data.hoeoud],
          100550: new Date().toISOString()

        };
        const idnewAdressData = await Api.dossiers.Create(newAdressData);

      } else if (this.state.key === 46663) {
        const newAdressData = {
          embedded: this.state.id,
          linkId: 19562,
          defDossier: 4620,
          93558: [46653],
          93561: [this.state.key],
          93579: [starFieldData.online],
          93580: [starFieldData.online_1],
          93581: [starFieldData.online_2],
          93585: [starFieldData.online_3],
          93586: [starFieldData.online_4],
          93587: [data.online_5],
          93588: [data.online_6],
          93589: [data.online_7],
          93594: [starFieldData.online_8],
          93595: [starFieldData.online_9],
          93596: [starFieldData.online_10],
          93892: `<p>${data.woorden}</p>`,
          93891: [data.hoeoud],
          100550: new Date().toISOString()
        };
        const idnewAdressData = await Api.dossiers.Create(newAdressData);

      } else if (this.state.key === 46665) {
        const newAdressData = {
          embedded: this.state.id,
          linkId: 19562,
          defDossier: 4620,
          93558: [46653],
          93561: [this.state.key],
          93579: [starFieldData.begeleiding_1],
          93580: [starFieldData.begeleiding_2],
          93581: [starFieldData.begeleiding_3],
          93585: [starFieldData.begeleiding_4],
          93586: [starFieldData.begeleiding_5],
          93587: [data.begeleiding_6],
          93588: [data.begeleiding_7],
          93589: [data.begeleiding_8],
          93594: [starFieldData.begeleiding_9],
          93595: [starFieldData.begeleiding_10],
          93596: [starFieldData.begeleiding_11],
          93892: `<p>${data.woorden}</p>`,
          93891: [data.hoeoud],
          100550: new Date().toISOString()

        };
        const idnewAdressData = await Api.dossiers.Create(newAdressData);

      }
    }

    this.setState({ loading: false, showModal: true });
  }

  handleStarFieldChange = (name, value) => {
    this.setState((prevState) => ({
      starFieldData: {
        ...prevState.starFieldData,
        [name]: value,
      },
    }));
  };

  SelectFieldStar(label, name, options, rules) {
    const {
      control,
      formState: { errors },
    } = this.props;

    const customStyles = {
      control: (provided) => ({
        ...provided,
        marginTop: "8px",
        width: "300px",
        padding: "0 8px",
        display: "flex",
        alignItems: "center",
        boxShadow: "none",
        borderColor: errors[name] ? "red" : "#ccc",
      }),
      singleValue: (provided) => ({
        ...provided,
        display: "flex",
        alignItems: "center",
        gap: "5px",
      }),
      placeholder: (provided) => ({
        ...provided,
        textAlign: "left",
      }),
    };

    const formattedOptions = options.map((opt) => ({
      value: opt.value,
      stars: opt.stars,
    }));

    return (
      <div className="flex flex-col items-start">
        <label className="form-label text-white fw-bold text-justify">
          {label}
        </label>

        <Controller
          name={name}
          control={control}
          rules={rules}
          render={({ field }) => (
            <Select
              {...field}
              options={formattedOptions}
              styles={customStyles}
              placeholder="Selecteer een optie"
              isClearable
              onChange={(selectedOption) => {
                field.onChange(selectedOption);
                this.handleStarFieldChange(
                  name,
                  selectedOption ? selectedOption.value : null
                );
              }}
              getOptionLabel={(e) => (
                <div
                  style={{ display: "flex", alignItems: "center", gap: "6px" }}
                >
                  {Array(e.stars)
                    .fill(null)
                    .map((_, idx) => (
                      <img
                        key={idx}
                        src={star}
                        alt="star"
                        style={{ width: 20, height: 20 }}
                      />
                    ))}
                </div>
              )}
            />
          )}
        />

        {errors[name] && (
          <span className="text-red-500 text-sm">Dit veld is verplicht</span>
        )}
      </div>
    );
  }

  handleSelectField(label, name, options, rules) {
    const { register } = this.props;
    const { type2 } = this.state;
    const selectedOption = options.find((opt) => opt.label === type2);

    return (
      <>
        <div className="flex flex-col items-start">
          <label
            htmlFor={name}
            className="form-label text-white fw-bold float-start"
          >
            {label}
          </label>

          <select
            {...register(name, rules)}
            name={name}
            defaultValue={selectedOption ? selectedOption.value : ""}
            onChange={(e) => {
              const selectedValue = e.target.value;
              let mappedValue;

              if (["46657", "46661", "46665"].includes(selectedValue)) {
                mappedValue = 1;
              } else if (["46656", "46660", "46664"].includes(selectedValue)) {
                mappedValue = 2;
              } else if (["46659", "46663"].includes(selectedValue)) {
                mappedValue = 3;
              } else if (["46658", "46662"].includes(selectedValue)) {
                mappedValue = 4;
              }
              this.setState({ case: mappedValue });
              this.setState({ [name]: [e.target.value] });
            }}
            className="h-10 border mt-1 rounded px-2 w-64 bg-gray-50"
          >
            {!type2 || !options.some((opt) => opt.label === type2) ? (
              <option value="">Selecteer een optie</option>
            ) : null}

            {options
              .filter((opt) => !type2 || opt.label === type2)
              .map((opt) => (
                <option
                  key={opt.value}
                  value={opt.value}
                  disabled={type2 && type2 !== opt.label}
                >
                  {opt.label}
                </option>
              ))}
          </select>
        </div>
      </>
    );
  }

  SelectField(label, name, options, rules) {
    const {
      register,
      formState: { errors },
    } = this.props;

    return (
      <>
        <div className="flex flex-col items-start">
          <label
            for="tussenvoegsels"
            className="form-label fw-bold text-white float-start"
          >
            {rules.required && <span className="text-red-500">*</span>} {label}
          </label>

          <select
            {...register(name, rules)}
            name={name}
            onChange={(e) => {
              const isJaSelected = e.target.value === "46669";
              this.setState({
                opt8: isJaSelected,
                [name]: [e.target.value],
              });
            }}
            className="h-10 border mt-1 rounded px-2 w-64 bg-gray-50"
          >
            <option value="">Selecteer een optie</option>
            {options.map((opt) => (
              <option value={opt.value}>{opt.label}</option>
            ))}
          </select>
          {errors[name]?.type === "required" && (
            <span className="text-red-500 text-sm">Dit veld is verplicht</span>
          )}
        </div>
      </>
    );
  }

  TextAreaField(label, name, rules = {}) {
    const {
      register,
      formState: { errors },
    } = this.props;

    return (
      <div className="flex flex-col items-start w-full">
        <label
          htmlFor={name}
          className="form-label text-white fw-bold float-start"
        >
          {rules.required && <span className="text-red-500">*</span>} {label}
        </label>
        <textarea
          id={name}
          rows={3}
          {...register(name, rules)}
          onChange={(e) => {
            this.setState({ [name]: e.target.value });
          }}
          className="block p-2 w-full text-sm text-gray-900 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
        ></textarea>
        {errors[name]?.type === "required" && (
          <span className="text-red-500 text-sm">This field is required</span>
        )}
      </div>
    );
  }

  async informatieForm(id) {
    this.setState({ id: id });
    const idnewAdressData = await Api.dossiers.Get(id);
    const content = idnewAdressData.content;

    const key = "93507";
    const textValue = content?.[key]?.[0]?.translations?.[0]?.text;

    const key2 = "93512";
    const textValue2 = content?.[key2]?.[0]?.translations?.[0]?.text;

    const key3 = "93513";
    const textValue3 = content?.[key3]?.[0]?.translations?.[0]?.text;

    const key4 = "93511";
    const textValue4 = content?.[key4]?.[0]?.translations?.[0]?.text;

    if (textValue) {
      this.setState({ type: textValue, key: content?.[key]?.[0]?.id });
    }

    if (textValue2) {
      this.setState({ type2: textValue2, key: content?.[key2]?.[0]?.id });
    } else if (textValue3) {
      this.setState({ type2: textValue3, key: content?.[key3]?.[0]?.id });
    } else if (textValue4) {
      this.setState({ type2: textValue4, key: content?.[key4]?.[0]?.id });
    }
  }

  componentDidMount() {
    const querystring = window.location.search;
    const params = new URLSearchParams(querystring);
    const id = params.get("id");

    this.informatieForm(id);
  }

  render() {
    const { handleSubmit } = this.props;

    return (
      <>
        {this.state.loading && (
          <div className="flex items-center justify-center h-screen fixed w-full z-50">
            <div className="bg-slate-500 absolute w-full h-full  opacity-50"></div>
            <div class="relative">
              <div className="h-24 w-24 rounded-full border-t-8 border-b-8 border-slate-200"></div>
              <div className="absolute top-0 left-0 h-24 w-24 rounded-full border-t-8 border-b-8 border-slate-300 animate-spin"></div>
            </div>
          </div>
        )}
        {this.state.showModal && (
          <div
            id="successModal"
            tabindex="-1"
            aria-hidden="true"
            class="flex  overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-modal md:h-full"
          >
            <div className="bg-slate-500 absolute w-full h-full opacity-50"></div>
            <div class="relative p-4 w-full max-w-md h-full md:h-auto">
              <div class="relative p-4 text-center bg-white rounded-lg shadow dark:bg-gray-800 sm:p-5">
                <button
                  onClick={() => {
                    this.setState({ showModal: false, finish: false });
                    this.props.reset();
                  }}
                  type="button"
                  class="text-gray-400 absolute top-2.5 right-2.5 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white"
                  data-modal-toggle="successModal"
                >
                  <svg
                    aria-hidden="true"
                    class="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                      clip-rule="evenodd"
                    ></path>
                  </svg>
                  <span class="sr-only">Close modal</span>
                </button>
                <div class="w-12 h-12 rounded-full bg-green-100 dark:bg-green-900 p-2 flex items-center justify-center mx-auto mb-3.5">
                  <svg
                    aria-hidden="true"
                    class="w-8 h-8 text-green-500 dark:text-green-400"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clip-rule="evenodd"
                    ></path>
                  </svg>
                  <span class="sr-only">Success</span>
                </div>
                <p class="mb-4 text-lg font-semibold text-gray-900 dark:text-white">
                  Bedankt voor het invullen
                </p>
                <button
                  onClick={() => {
                    this.setState({ showModal: false, finish: false });
                  }}
                  type="button"
                  class="py-2 px-3 text-sm font-medium text-center text-white rounded-lg bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 "
                >
                  Ga door
                </button>
              </div>
            </div>
          </div>
        )}
        <div
          className="py-5 px-6 sm:px-10 md:px-16 lg:px-20 flex flex-col"
          style={{
            backgroundImage: `url(${logo})`,
            backgroundSize: "cover",
            backgroundPosition: "top",
            backgroundRepeat: "no-repeat",
            backgroundAttachment: "fixed",
            width: "100%",
            minHeight: "100vh",
          }}
        >
          {this.state.finish && (
            <div className="mt-2 p-2 bg-white/10 rounded-lg shadow-md text-center backdrop-blur-md">
              <h2 className="text-xl font-bold text-white">
                Welkom bij Dynamo
              </h2>
              <p className="text-white mt-2">Wat jij vindt is belangrijk.</p>
              <p className="text-white mt-2">Waardeer ons met sterren.</p>
              <p className="text-white mt-2">Vul in en klik op indienen</p>
              <p className="text-white  mt-2">Alvast heel erg bedankt.</p>
            </div>
          )}

          {this.state.finish &&
            (this.state.type === "Buurtgericht" ? (
              <div onSubmit={this.submitForm}>
                <Buurtgericht
                  case={this.state.case}
                  SelectField={this.SelectField}
                  SelectFieldStar={this.SelectFieldStar}
                  TextAreaField={this.TextAreaField}
                  submitForm={this.submitForm}
                  case2={this.state.type2}
                />

                {[1, 2].includes(this.state.case) || this.state.type2 ? (
                  <div className="mt-3" onSubmit={handleSubmit(this.onSubmit)}>
                    <form>
                      <button
                        type="submit"
                        className="bg-blue-700 text-white font-bold px-6 py-2 rounded-3xl flex justify-center items-center hover:border hover:border-blue-500 transition duration-300 ease-in-out"
                      >
                        Indienen
                      </button>
                    </form>
                  </div>
                ) : null}
              </div>
            ) : this.state.type === "Groepsgericht" ? (
              <div onSubmit={this.submitForm}>
                <Groepsgericht
                  case={this.state.case}
                  SelectField={this.SelectField}
                  SelectFieldStar={this.SelectFieldStar}
                  TextAreaField={this.TextAreaField}
                  submitForm={this.submitForm}
                  case2={this.state.type2}
                  opt8={this.state.opt8}
                />

                {[1, 2].includes(this.state.case) || this.state.type2 ? (
                  <div className="mt-3" onSubmit={handleSubmit(this.onSubmit)}>
                    <form>
                      <button
                        type="submit"
                        className="bg-blue-700 text-white font-bold px-6 py-2 rounded-3xl flex justify-center items-center hover:border hover:border-blue-500 transition duration-300 ease-in-out"
                      >
                        Indienen
                      </button>
                    </form>
                  </div>
                ) : null}
              </div>
            ) : this.state.type === "Persoonsgericht" ? (
              <div onSubmit={this.submitForm}>
                <Persoonsgericht
                  case={this.state.case}
                  SelectField={this.SelectField}
                  SelectFieldStar={this.SelectFieldStar}
                  TextAreaField={this.TextAreaField}
                  submitForm={this.submitForm}
                  case2={this.state.type2}
                  opt8={this.state.opt8}
                />

                {[1, 2].includes(this.state.case) || this.state.type2 ? (
                  <div className="mt-3" onSubmit={handleSubmit(this.onSubmit)}>
                    <form>
                      <button
                        type="submit"
                        className="bg-blue-700 text-white font-bold px-6 py-2 rounded-3xl flex justify-center items-center hover:border hover:border-blue-500 transition duration-300 ease-in-out"
                      >
                        Indienen
                      </button>
                    </form>
                  </div>
                ) : null}
              </div>
            ) : null)}

          {!this.state.finish && (
            <div className="flex flex-row justify-between mt-10 bg-white rounded-lg shadow-md border border-gray-200 p-6">
              <p className="text-start text-xl font-bold flex items-center">
                Bedankt voor het invullen.
                <span className="ml-2">
                  <img
                    src={adios}
                    alt="adios"
                    style={{ width: 20, height: 20 }}
                  />
                </span>
              </p>
            </div>
          )}
        </div>
      </>
    );
  }
}

export default Dynamo;
